import {BasePageLayout} from "../components/grouping/BasePageLayout";
import {usePages} from "../api/pageapi";

export function GeneralManagementPage(props) {
    const {pages} = usePages();

    return <BasePageLayout>
        <div dangerouslySetInnerHTML={{__html: pages? pages[2]?.htmlFragment?.html:""}}>

        </div>
    </BasePageLayout>
}